module.exports = __webpack_public_path__ + "static/media/img_splash1.3c3b69db.png";